import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFromBack',
})
export class DateFromBackPipe implements PipeTransform {

  transform(date? : string): string {
    let transformedData : string = '';
    if (date) {
      transformedData = date.slice(0, 10).split('-').reverse().join('/');
    }
    return transformedData;
  }

}
